import { App } from './App';
import { NeuralNetworkSimulator } from './NeuralNetworkSimulator';
import { comparePsychicPotential } from './PsychicPotential';

async function ensureFreshDeployment(): Promise<void> {
	try {
		const currentBuildId = (import.meta as any).env?.VITE_BUILD_ID as string | undefined;
		const storedBuildId = window.localStorage.getItem('buildId') || undefined;

		if (!currentBuildId) {
			return; // Nothing to compare; skip
		}

		if (storedBuildId !== currentBuildId) {
			window.localStorage.setItem('buildId', currentBuildId);
			try {
				window.sessionStorage.clear();
			} catch {}
			if ('caches' in window) {
				try {
					const keys = await caches.keys();
					await Promise.all(keys.map(k => caches.delete(k)));
				} catch {}
			}
			window.location.reload();
		}
	} catch {
		// Non-fatal; continue boot
	}
}

async function bootstrap() {
	await ensureFreshDeployment();
	const app = new App();
	app.init();

	(window as any).compareNetwork = () => {
		const other = new NeuralNetworkSimulator();
		return comparePsychicPotential(app.network, other);
	};

	// Expose creature voice test method
	(window as any).testCreatureVoice = () => {
		app.network.creatureVoice.testVoice();
	};
}

bootstrap();